module.exports = __webpack_public_path__ + "static/media/800.ae37bfe1.webp";